"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _hooks = require("../../hooks");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
const useStyles = (isHidden, zIndex) => {
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const {
    fontFamily,
    themeColors
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    pxToRem,
    setStartDirection
  } = (0, _hooks.useStylesUtils)();
  const ccSnackbarStyle = (0, _react.useMemo)(() => {
    const hiddenProps = () => {
      return isHidden ? {
        opacity: 0,
        pointerEvents: 'none',
        transition: 'opacity 1s linear'
      } : {};
    };
    const deviceProps = () => {
      return isMobileView ? {
        // Mobile Props
        background: themeColors?.general.success,
        opacity: 1,
        transition: 'opacity 0.25s linear',
        fontSize: pxToRem(16),
        bottom: pxToRem(72),
        padding: `${pxToRem(8)} ${pxToRem(12)}`,
        margin: 0,
        left: 0,
        right: 0,
        pointerEvents: 'none',
        '& p': {
          textAlign: 'center',
          margin: 0,
          padding: 0,
          lineHeight: 1.2
        }
      } : {
        // PC Props
        background: themeColors?.basic.dark,
        opacity: 0.9,
        fontSize: pxToRem(14),
        bottom: pxToRem(16),
        padding: `0 ${pxToRem(12)}`,
        margin: pxToRem(4),
        border: `1px solid ${themeColors?.general.light}`,
        borderRadius: pxToRem(4),
        boxShadow: `0 ${pxToRem(4)} ${pxToRem(7)} 0 ${themeColors?.basic.shadow}`,
        maxWidth: '80vw',
        '& p': {
          margin: `${pxToRem(8)} 0`,
          lineHeight: 1.2
        },
        ...setStartDirection(16)
      };
    };
    const ccSnackbar = (0, _css.css)({
      fontFamily: fontFamily,
      color: themeColors?.general.light,
      position: 'fixed',
      zIndex: zIndex ?? 'auto',
      ...deviceProps(),
      ...hiddenProps()
    });
    return {
      ccSnackbar
    };
  }, [fontFamily, isHidden, isMobileView, pxToRem, setStartDirection, themeColors?.basic.dark, themeColors?.basic.shadow, themeColors?.general.light, themeColors?.general.success, zIndex]);
  return {
    'cc-Snackbar': ccSnackbarStyle.ccSnackbar
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;